import { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock, ArrowRight, ShieldCheck } from "lucide-react";
import { API } from "../lib/api";

export default function SetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token");
  const [pwd, setPwd] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    if (pwd.length < 6) return toast.error("6 caractères minimum");
    if (pwd !== confirm) return toast.error("Les mots de passe ne correspondent pas");
    setLoading(true);
    try {
      const res = await fetch(`${API}/auth/set-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, password: pwd }),
      });
      const j = await res.json();
      if (!res.ok) throw new Error(j.detail || "err");
      toast.success("Mot de passe créé ! Connectez-vous.");
      navigate("/login");
    } catch (e) {
      toast.error(e.message || "Lien invalide ou expiré");
      setLoading(false);
    }
  };

  if (!token)
    return (
      <div className="min-h-screen bg-[#09090b] text-white flex items-center justify-center px-6 font-['Manrope']">
        <p data-testid="setpwd-invalid">Lien invalide.</p>
      </div>
    );

  return (
    <div className="min-h-screen bg-[#09090b] text-white flex items-center justify-center px-6 font-['Manrope']">
      <div className="w-full max-w-md bg-zinc-900 border border-zinc-800 rounded-lg p-8" data-testid="setpwd-page">
        <ShieldCheck size={40} className="text-indigo-400 mb-4" />
        <h1 className="font-['Outfit'] font-black text-3xl tracking-tight mb-2">Créez votre mot de passe</h1>
        <p className="text-zinc-400 text-sm mb-6">Choisissez un mot de passe sécurisé pour accéder à MobicarsVSD.</p>
        {[["Mot de passe", pwd, setPwd, "setpwd-input"], ["Confirmer", confirm, setConfirm, "setpwd-confirm"]].map(
          ([label, val, setter, tid]) => (
            <div key={tid} className="mb-4">
              <label className="text-xs uppercase tracking-widest text-zinc-500 font-bold">{label}</label>
              <div className="mt-2 flex items-center gap-2 border border-zinc-700 rounded-md px-3 bg-zinc-950 focus-within:border-indigo-500 transition-colors">
                <Lock size={18} className="text-zinc-500" />
                <input
                  data-testid={tid}
                  type="password"
                  value={val}
                  onChange={(e) => setter(e.target.value)}
                  onKeyDown={(e) => e.key === "Enter" && submit()}
                  className="flex-1 bg-transparent py-3 text-white outline-none"
                />
              </div>
            </div>
          )
        )}
        <button
          data-testid="setpwd-submit"
          onClick={submit}
          disabled={loading}
          className="mt-2 w-full inline-flex items-center justify-center gap-2 bg-white text-zinc-950 font-bold px-6 py-3.5 rounded-md hover:bg-zinc-200 transition-colors disabled:opacity-60"
        >
          {loading ? "…" : <>Valider <ArrowRight size={18} strokeWidth={2.5} /></>}
        </button>
      </div>
    </div>
  );
}
